import React, { useEffect } from 'react';
import { initializeFullStory } from './fullstoryUtils';
import { useSelector } from 'react-redux';
import { webConfig } from 'webConfig';
import { AppState } from 'store';
import { Features } from 'store/featureFlags/types';

export const FullStory: React.FC = () => {
    const { fullStoryEnabled } = useSelector((state: AppState) => ({
        fullStoryEnabled: state.FeatureFlagging.features[Features.FULLSTORY],
    }));

    useEffect(() => {
        if (!fullStoryEnabled) return;
        initializeFullStory(webConfig.fullStoryOrgId);
    }, [fullStoryEnabled]);

    return null;
}